/* Program Name: TabPanel.js
 **  Description: a wrapper class that contains the logic for tab panels to function
 **               with the MUI Tab and Tabs
 **
 ** Project    Date        Who  Comments
 ** ---------  ----------  ---  ---------------------------------------------------
 ** IS0200241  2021-05-14  STT  Initial program
 *********************************************************************************/

/**React imports */
import React from 'react'

/**Material UI imports */
import { Box } from '@mui/material'

/**TabPanel *********************************************************************/
const TabPanel = ({ children, value, index, maxHeight }) => {
  /****************************************************************************/
  /**Render */

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      style={{ height: maxHeight ? '70vh' : null }}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  )
}

export default TabPanel
